/**
 * Sets the location inventory quantity information 
 * Load after DOM
 */
document.addEventListener('DOMContentLoaded', function() {

});

/**
 * Load after ALL resorces
 */
window.addEventListener("load", (event) => {
  const initial_id = document.querySelector('[name=id]').getAttribute('value');
  
  console.log('Initial ID: ' + initial_id);
  
  setTimeout(() => {
    console.log('start');
    
    fetchAvailability(initial_id);
  }, 150);
 
  
});

/**
 * 
 * @param {*} variant_id 
 */
function set_inventory_quantity(variant_id) {
  const phpEndpoint = "https://shopify.api.nomilk.dev/bogo/locations-data.php";

  console.log("The received ID:", variant_id);

  fetch(phpEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ variantId: variant_id }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // The GraphQL result
      console.log("___________");
      console.log(data);

      const graphQLResult = data.data.productVariant.inventoryItem.inventoryLevels.edges;

      const locationInventory = {};

      // Process the quantities field instead of available
      graphQLResult.forEach((item) => {
        const locationId = item.node.location.id.split("/").pop(); // Extract the ID from the GID
        const quantities = item.node.quantities; // Use the new quantities field

        // Extract the "on_hand" quantity (if available)
        const onHandQuantity = quantities.find((q) => q.name === "on_hand")?.quantity || 0;

        locationInventory[locationId] = onHandQuantity; // Store the "on_hand" quantity
      });

      console.log("LocationInventory");

      if (graphQLResult) {
        setTimeout(() => {
          const locationElems = document.querySelectorAll(".pickup-availability-list__item");

          locationElems.forEach((locationElem) => {
            const locationId = locationElem.getAttribute("data-location-id");
            const locationItems = document.querySelectorAll(
              '[data-location-id="' + locationId + '"]'
            );

            const availableInventory = locationInventory[locationId];
            const descriptionElem = locationElem.querySelector(".description-text");
            const colorElem = locationElem.querySelector(".color-item");
            const inventoryElement = locationElem.querySelector(".inventory-element");
            inventoryElement.classList.add("hidden");

            if (typeof availableInventory !== "undefined") {
              const quantityElem = locationElem.querySelector(".inventory-quantity");
              if (inventoryElement) {
                if (availableInventory < 1) {
                  locationItems.forEach(function (elem) {
                    elem.setAttribute("data-stocktype", "out-of-stock");
                  });
                } else if (availableInventory > 900) {
                  locationElem.setAttribute("data-stocktype", "backorder");
                } else {
                  locationElem.setAttribute("data-available-stock", availableInventory);
                  locationElem.setAttribute("data-stocktype", "in-stock");
                }
              }
            }
          });
        }, 300);
      } else {
        console.error("Failed to fetch inventory.");
      }
    })
    .then(() => {
      const inventoryDisplays = document.querySelectorAll(".inventory-display");
      const spinners = document.querySelectorAll(".spinner");

      inventoryDisplays.forEach((elem) => (elem.style.display = "block"));
      spinners.forEach((elem) => (elem.style.display = "none"));
    })
    .catch((error) => {
      console.error("There was a problem fetching the inventory data:", error);
    });
}


/**
 * Insert the availability DOM into product page
 * @param {*int} variantId 
 */
function fetchAvailability(variantId) {
  /**
   * Fetch the section content and populate
   */
  const variantSectionUrl = `variants/${variantId}/?section_id=pickup-availability`;

  fetch(window.Shopify.routes.root + variantSectionUrl)
    .then((response) => response.text())
    .then((text) => {
      const container = document.querySelector('[data-store-availability-container]');
      const pickupAvailabilityHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section');

      if (!container || !pickupAvailabilityHTML) return;

      // Remove old variant availability before inserting the new one
      container.innerHTML = '';
      container.appendChild(pickupAvailabilityHTML);
    })
    .then(() => {
      set_inventory_quantity(variantId);
    })
    .catch((e) => {
      console.error(e);
    });
}